import _ from 'lodash'
import moment from 'moment'

export default subscriptionSummaryCtrl

/** @ngInject */
function subscriptionSummaryCtrl($scope, $state, ContractDraft, MobilePhone, ContactTelephone, ErrorCatcher, contractDraft, timeline, subscriptionToken) {
    $scope.isLoading = false
    $scope.isDisplayedExtendedLegalNotice = false
    $scope.contactTelephone = ContactTelephone
    $scope.contractDraft = contractDraft
    $scope.timeline = timeline
    $scope.retractEndDate = moment().add(14, 'days')
    $scope.enablePayment = false
    $scope.form = {
        hasConsentCurves: false,
        hasConsentIndex: false,
    }

    $scope.goToPayment = function () {
        if ($scope.enablePayment !== true) {
            return
        }
        const consentPayload = { consent_curves: $scope.form.hasConsentCurves, consent_index: $scope.form.hasConsentIndex }
        const updatePromise = _.isEmpty(subscriptionToken)
            ? ContractDraft.update({}, consentPayload).$promise
            : ContractDraft.updateByToken({ token: subscriptionToken }, consentPayload).$promise
        $scope.isLoading = true
        updatePromise.then(() => {
            const getPaymentIframePromise = _.isEmpty(subscriptionToken)
                ? ContractDraft.getPaymentIframe({ id: contractDraft.id }).$promise
                : ContractDraft.getPaymentIframeByToken({ id: contractDraft.id, token: subscriptionToken }).$promise
            getPaymentIframePromise
            .then((response) => {
                window.location = response.redirectUrl
            })
            .catch((error) => {
                ErrorCatcher.catchError(error)
            })
        })
        .catch(ErrorCatcher.catchError)
        .finally(() => {
            this.isLoading = false
        })
    }

    $scope.getSleekSentence = () => {
        if (contractDraft.sleek_timetable) {
            return `Lissé, par périodes de ${contractDraft.billing_modality === '12month' ? 12 : 6} mois`
        }
        return 'Réel'
    }

    $scope.isShowroom = () => _.startsWith($scope.contractDraft.id_ref_promo, 'SRP')

    $scope.formatTo0607 = _.flow(MobilePhone.formatPhoneTo0607, MobilePhone.formatPhoneToSpacePhone)

    $scope.formatCalendar = (calendar) => _.get({ BASE: 'Base', HPHC: 'Heures Pleines / Heures Creuses' }, calendar, calendar)

    $scope.getAmountFromTimeline = (timelineMonth) => _.get(timelineMonth, contractDraft.sleek_timetable ? 'sleeked' : 'amount')

    $scope.showExtendedLegalNotice = () => {
        $scope.isDisplayedExtendedLegalNotice = true
    }

    // Get next Billing date (enedis reading date + 1 month)
    const getNextBillingDate = () => moment(contractDraft.nextBillableDate).add(15, 'day')

    const computeEnedisPrestations = () => ContractDraft.computeEnedisPrestations(null, {
        id_contract: contractDraft.id,
        prestationType: contractDraft.subscription_type,
        specialReport: contractDraft.force_intervention,
        choosen_mes_type: contractDraft.choosen_mes_type || 'NORMAL',
        choosen_max_power: contractDraft.choosen_max_power || contractDraft.max_power,
        choosen_id_p_calendar: contractDraft.choosen_id_p_calendar || contractDraft.id_p_calendar,
    }).$promise.then((prestation) => {
        $scope.enedisPrestations = prestation
    }).catch((error) => {
        ErrorCatcher.catchError(error)
    })

    const checkPromo = () => {
        if (_.get($scope, 'contractDraft.id_ref_promo.length') > 0) {
            $scope.errorPromo = false
            return ContractDraft.checkPromoOnDraft({ id_draft: contractDraft.id, promo: contractDraft.id_ref_promo, soft: true }).$promise
            .then(() => {
                return $scope.errorPromo
            })
            .catch((error) => {
                $scope.errorPromo = error
            })
        }
    }

    const activate = () => {
        $scope.form.hasConsentIndex = !!_.get($scope.contractDraft, 'consent_index', null)
        $scope.form.hasConsentCurves = !!_.get($scope.contractDraft, 'consent_curves', null)
        $scope.currentMonthTimeline = _.get(timeline, 0)
        $scope.nextMonthTimeline = _.get(timeline, 1)
        $scope.nextBillingDate = getNextBillingDate()
        checkPromo()
        computeEnedisPrestations()
    }

    activate()
}



// WEBPACK FOOTER //
// ./src/states/subscriptionSummary/subscriptionSummary.js